import { SchedulerOMS } from '@lp/features/Scheduler';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerPermissions } from '@/permissions';
import { EmployeeRole } from '@/api/apis/resources';

export const OMSSchedule = () => {
  const { checkPermission, roles } = useAuthContext();
  const readonly = !checkPermission(SchedulerPermissions.OMSSchedulesWrite);
  const isOMS = roles.includes(EmployeeRole.OrganManagementSpecialist);

  return <SchedulerOMS readonly={readonly} withPersonalView={isOMS} />;
};
